import { FC, Fragment } from "react";
import { FormControl, RadioGroup } from "@material-ui/core";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { useStyles } from "../../useStyles";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";

export const ChargerConnectionExteriorTypesForm: FC = () => {
    const classes = useStyles();
    const { values, setValues, submitChange } =
        useFormModel<ChangeNames.CHARGER_CONNECTION_EXTERIOR_TYPE>();

    const convertValue = (): string => {
        if (values.chargerConnectionExteriorTypes.value.connectionPillar) return "connectionPillar";
        if (values.chargerConnectionExteriorTypes.value.connectionPillarWithMeter)
            return "WithMeter";
        if (values.chargerConnectionExteriorTypes.value.chargerPillar) return "chargerPillar";
        return "";
    };

    const selection = convertValue();

    return (
        <Fragment>
            <div className={classes.container} style={{ marginBottom: 20 }}>
                <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 20 }}>
                    Art des Anschlusses
                </h4>
                <FormControl component="fieldset" style={{ display: "flex" }}>
                    <RadioGroup
                        value={selection}
                        onChange={(e, v) => {
                            const newValues = setValues((values) => {
                                values.chargerConnectionExteriorTypes.value = {
                                    connectionPillar: v.indexOf("connectionPillar") >= 0,
                                    connectionPillarWithMeter: v.indexOf("WithMeter") >= 0,
                                    chargerPillar: v.indexOf("chargerPillar") >= 0,
                                };
                            });
                            submitChange(newValues);
                        }}
                    >
                        <FormControlLabel
                            value="connectionPillar"
                            control={<Radio />}
                            label="Hausanschlusssäule"
                            text="Die Hausanschlusssäule beinhaltet nur den Netzanschluss."
                            error={values.chargerConnectionExteriorTypes.error !== null}
                        />
                        <FormControlLabel
                            value="WithMeter"
                            control={<Radio />}
                            label="Zähleranschlusssäule"
                            text="Die Zähleranschlusssäule beinhaltet neben dem Netzanschluss auch die Zähleranlage.<br />
                            Die Zähleranschlusssäule ist bauseits durch Ihren Elektroinstallateur zu beziehen."
                            error={values.chargerConnectionExteriorTypes.error !== null}
                        />
                        <FormControlLabel
                            value="chargerPillar"
                            control={<Radio />}
                            label="Ladesäule"
                            text="Die Ladesäule beinhaltet neben dem Netzanschluss auch die Zähleranlage sowie die Ladepunkte. Es ist keine zusätzliche Anschlusssäule erforderlich."
                            error={values.chargerConnectionExteriorTypes.error !== null}
                        />
                    </RadioGroup>
                </FormControl>
            </div>
        </Fragment>
    );
};
